import MachineTechniciansContainer from './machine-technicians-container';

export default MachineTechniciansContainer;
